import { render, staticRenderFns } from "./EducationNotesPreview.vue?vue&type=template&id=1dbc9806&scoped=true"
import script from "./EducationNotesPreview.vue?vue&type=script&lang=ts"
export * from "./EducationNotesPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc9806",
  null
  
)

export default component.exports